import React, { useEffect, useRef, useState } from "react"
import { getLocation } from "../../utils/getLocation"
import { StaticImage } from "gatsby-plugin-image"
import styled, { keyframes } from "styled-components"
import { Container } from "../Container"
import { Burger } from "../Burger"
import { focusAreas } from "../../config/navigation"

import { useOpen } from "../../hooks/useOpen"
import { Icon } from "../Icon"
import MyLink from "../../utils/checkExternalLink"
import { useNoScroll } from "../../hooks/useNoScroll"
import { useOnClickOutside } from "../../hooks/useOnClickOutside"
import { MobileFlexSearchBtn } from "../FlexSearch/mobileFlexSearchBtn/mobileFlexSearchBtn"
import { MobileFlexSearchModal } from "../FlexSearch/mobileFlexSearchModal/mobileFlexSearchModal"
import { DesktopHeaderSearch } from "../FlexSearch/desktopHeaderSearch/desktopHeaderSearch"
import { Link } from "gatsby"

const Header = ({ data, location }) => {
  const headerNavigationList = data.headerNavigation.map(item =>
    item.sub_links === "focus_areas" ? { ...item, sub_links: focusAreas } : item
  )
  const { isOpen: isMobileOpenMenu, onToggle: onToggleMobileMenu } = useOpen()
  const {
    isOpen: isMobileSearchModalOpen,
    onOpen: onOpenMobileSearchModal,
    onClose: onCloseMobileSearchModal,
  } = useOpen()
  const [flexSearch, setFlexSearch] = useState("")
  const [currentMenuTitle, setCurrentMenuTitle] = useState("Home")
  useNoScroll(isMobileOpenMenu)
  const modalRef = useRef(null)
  useOnClickOutside(modalRef, onCloseMobileSearchModal)
  useEffect(() => {
    setCurrentMenuTitle(headerNavigationList.find(item => item.link_url === location?.pathname) ? headerNavigationList.find(item => item.link_url === location?.pathname).label : location?.pathname ? "Focus Areas" : "Home");
  }, []);
  return (
    <>
      <Wrapper>
        <Container>
          <Box className="headerBox">
            <ImageWrapper>
              <MyLink href="/">
                <StaticImage
                  src="./images/logoWhite.png"
                  alt="logo"
                  objectFit="contain"
                />
              </MyLink>
            </ImageWrapper>
            <NavWrapper>
              <MobileFlexSearchBtn onOpenModal={onOpenMobileSearchModal} />
              <DesktopHeaderSearch
                searchedString={flexSearch}
                setSearchedString={setFlexSearch}
              />
              <CalendarLink href="/calendar">
                <Icon type="CALENDAR_ICON" width={24} height={24} />
              </CalendarLink>
              <Social
                href="https://www.linkedin.com/company/ecr-community-shrink-and-osa-group/"
                target="_blank"
              >
                <Icon type="LINKEDIN_MAIN" width={24} height={24} />
              </Social>
              <WrapperMenu>
                <MenuTitle>
                  <span>{currentMenuTitle}</span>
                  <Icon type="ARROW" />
                </MenuTitle>
                <NavigationWrapper
                  isOpenMenu={onToggleMobileMenu}
                  isMobileOpenMenu={isMobileOpenMenu}
                >
                  <NavigationWrapperInner>
                    <StaticImage
                      className="header-bg"
                      src="./images/background.png"
                      alt="background"
                      objectFit="cover"
                      objectPosition="right bottom"
                    />
                    <MainMenu>
                      {headerNavigationList.map((item, i) => {
                        const locationCurrent =
                          location?.pathname?.split("/")[1]
                        const isCurrentLocation = !locationCurrent
                          ? `/${locationCurrent}` === item.link_url
                          : item?.link_url?.includes(locationCurrent)

                        return !item.sub_links ? (
                          <li
                            key={i}
                            className={
                              isCurrentLocation
                                ? "underline"
                                : locationCurrent === "webinar" &&
                                  item.link_url === "/event"
                                ? "underline"
                                : ""
                            }
                          >
                            <MyLink href={item.link_url}>{item.label}</MyLink>
                          </li>
                        ) : (
                          <li className="subLink" key={i}>
                            <span>{item.label}</span>
                            <Icon type="LIST_ICON" />
                            <ul>
                              {item.sub_links?.map((item, i) => {
                                const locationCurrent =
                                  location?.pathname?.split("/")[2]
                                const isCurrentLocation =
                                  `${locationCurrent}` ===
                                  item.link_url.split("/")[2]
                                return (
                                  <li
                                    key={i}
                                    className={
                                      isCurrentLocation ? "underline" : ""
                                    }
                                  >
                                    <MyLink href={item.link_url}>
                                      {item.label}
                                    </MyLink>
                                  </li>
                                )
                              })}
                            </ul>
                          </li>
                        )
                      })}
                    </MainMenu>
                    <ButtonMobile>
                      <MyLink href="https://ecr-shrink-group.us17.list-manage.com/subscribe?u=6023bad92de17c3cdf8bb689d&id=fe6105ee15">
                        Join our mailing list
                      </MyLink>
                    </ButtonMobile>
                    <CopyRight>
                      <p>© 2023 ECR Retails Loss. All Rights Reserved</p>
                      <MyLink href="/privacy">Privacy Policy</MyLink>
                    </CopyRight>
                  </NavigationWrapperInner>
                </NavigationWrapper>
              </WrapperMenu>
              <ButtonDesktop>
                <MyLink href="https://ecr-shrink-group.us17.list-manage.com/subscribe?u=6023bad92de17c3cdf8bb689d&id=fe6105ee15">
                  Join our mailing list
                </MyLink>
              </ButtonDesktop>
            </NavWrapper>
            <Burger
              isOpen={isMobileOpenMenu}
              burgerToggle={() => onToggleMobileMenu()}
            />
          </Box>
        </Container>
      </Wrapper>
      <MobileFlexSearchModal
        modalRef={modalRef}
        searchedString={flexSearch}
        setSearchedString={setFlexSearch}
        isOpen={isMobileSearchModalOpen}
      />
    </>
  )
}

export default Header

const pulse = keyframes`
  50% {
    transform: scale(2);
    opacity: 0
  }
  100% {
    transform: scale(2);
    opacity: 0
  }
`

const Wrapper = styled.div`
  width: 100%;
  position: absolute;
  height: 50px;
  z-index: 100;

  &:after {
    content: "";
    position: absolute;
    width: 100%;
    height: 1px;
    bottom: 0;
    background: ${({ theme }) => theme.colors.white};
    z-index: 20;
  }

  @media (min-width: ${({ theme }) => theme.media.desktop_min}) {
    height: 100px;
  }
`

const ImageWrapper = styled.div`
  z-index: 20;
  flex-shrink: 0;

  .gatsby-image-wrapper {
    width: 33px;
    height: 33px;

    @media (min-width: ${({ theme }) => theme.media.desktop_min}) {
      width: 55px;
      height: 60px;
    }

    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }
`

const CalendarLink = styled(Link)`
  display: flex;
  position: relative;

  svg {
    fill: white;
    transition: 0.3s ease-out;
  }

  &:hover {
    svg {
      fill: ${({ theme }) => theme.colors.primary_color};
    }
  }

  &::after {
    content: " ";
    width: 10px;
    height: 10px;
    border-radius: 50%;
    transition: all 0.3s;
    background-color: ${({ theme }) => theme.colors.secondary_color};
    animation: ${pulse} 2s infinite;
    border-radius: 50%;
    position: absolute;
    bottom: 1px;
    left: 0px;
  }
`

const NavWrapper = styled.nav`
  display: flex;
  align-items: center;
  gap: 1rem;

  @media (min-width: ${({ theme }) => theme.media.tablet_min}) {
    gap: 1rem;
  }
`
const Social = styled.a`
  color: ${({ theme }) => theme.colors.primary_color};
  display: grid;
  place-items: center;
  transition: ${({ theme }) => theme.durations.transition};

  &:hover {
    opacity: 0.7;
  }
`
const WrapperMenu = styled.button`
  background: none;
  @media (min-width: ${({ theme }) => theme.media.desktop_min}) {
    display: flex;
    padding: 0 8px;
    min-width: 230px;
    min-height: 38px;
    background: transparent;
    text-align: center;
    font-family: ${({ theme }) => theme.fonts.primary_font};
    font-size: 1rem;
    font-weight: 500;
    cursor: default;
    background: ${({ theme }) => theme.colors.primary_color};
    color: ${({ theme }) => theme.colors.white};
    position: relative;
    align-items: center;
    justify-content: space-between;
    z-index: 30;
    line-height: 1.62;
    transition: 0.3s;

    &:before {
      content: "";
      position: absolute;
      top: 100%;
      left: 0;
      width: 100%;
      height: 10px;
    }
  }

  @media (min-width: ${({ theme }) => theme.media.desktop_min}) {
    &:hover,
    &:focus {
      ul {
        display: block;
      }
    }
  }
`

const MenuTitle = styled.span`
  display: none;
  @media (min-width: ${({ theme }) => theme.media.desktop_min}) {
    display: inline-block;
  }

  svg {
    position: absolute;
    right: 12px;
    top: 16px;
  }

  @media (max-width: ${({ theme }) => theme.media.desktop_min}) {
    display: none;
    background-color: transparent;
  }
`

const NavigationWrapperInner = styled.div`
  overflow: auto;
  height: 100%;
  margin: 50px 0 20px;
  width: 100%;
  padding: 20px 45px 0;

  @media (min-width: ${({ theme }) => theme.media.desktop_min}) {
    overflow: visible;
    margin: 30px 0;
    height: auto;
    width: auto;
    padding: 0;
  }
`

const NavigationWrapper = styled.div`
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  display: ${({ isMobileOpenMenu }) => (isMobileOpenMenu ? "flex" : "none")};
  z-index: 10;
  background-color: ${({ theme }) => theme.colors.white};
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
  height: 100%;
  @media (min-width: ${({ theme }) => theme.media.desktop_min}) {
    background: transparent;
    display: block;
    position: absolute;
    top: 5px;
    left: 0;
    z-index: 30;
    height: auto;
  }

  &:before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
    clip-path: polygon(0 0, 94% 0, 93% 97%, 0% 100%);
    background-color: ${({ theme }) => theme.colors.primary_color};
    box-shadow: ${({ theme }) => theme.box.boxShadow};
    @media (min-width: ${({ theme }) => theme.media.desktop_min}) {
      content: none;
    }
  }

  &:after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 94%;
    height: 95%;
    z-index: 0;
    background-color: rgba(0, 0, 0, 0.25);
    box-shadow: ${({ theme }) => theme.box.boxShadow};
    @media (min-width: ${({ theme }) => theme.media.desktop_min}) {
      content: none;
    }
  }

  .header-bg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    @media (min-width: ${({ theme }) => theme.media.desktop_min}) {
      display: none;
    }
  }
`

const MainMenu = styled.ul`
  position: relative;
  z-index: 3;
  text-align: left;
  width: 70%;
  margin-bottom: 0;

  @media (min-width: ${({ theme }) => theme.media.desktop_min}) {
    position: absolute;
    background: ${({ theme }) => theme.colors.primary_color};
    top: 38px;
    width: 100%;
    padding: 4px 0;
    display: none;
  }

  li {
    position: relative;
    width: max-content;
    margin: 0 auto 0 0;
    @media (min-width: ${({ theme }) => theme.media.desktop_min}) {
      display: flex;
      align-items: center;
    }
    @media (max-width: ${({ theme }) => theme.media.desktop_min}) {
      font-size: 25px;
      font-weight: 600;
      color: ${({ theme }) => theme.colors.white};
      margin-bottom: 10px;
      &::after {
        position: absolute;
        content: "";
        width: 0;
        height: 2px;
        left: 0;
        bottom: 0;
        background: white;
        transition: ${({ theme }) => theme.durations.transition};
      }
    }

    &:hover:not(:nth-last-child(2)) {
      &::after {
        width: 100%;
        transition: ${({ theme }) => theme.durations.transition};
      }
    }

    a {
      display: block;
      width: 100%;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }

    &.underline {
      &::after {
        width: 100%;
      }
    }
  }

  .subLink {
    span {
      font-family: ${({ theme }) => theme.fonts.primary_font};
    }
    a {
      @media (max-width: 767px) {
        cursor: default;
      }
    }

    svg {
      width: 19px;
      height: 19px;
      margin-left: 14px;
      @media (min-width: ${({ theme }) => theme.media.desktop_min}) {
        display: none;
      }
    }

    ul {
      @media (min-width: ${({ theme }) => theme.media.desktop_min}) {
        width: 100%;
        position: absolute;
        display: none;
        box-shadow: ${({ theme }) => theme.box.boxShadow};
      }

      li {
        cursor: pointer;

        a {
          cursor: pointer;
          font-size: 16px;
          font-weight: 500;
        }

        @media (max-width: 767px) {
          &::after {
            position: absolute;
            content: "";
            width: 0;
            height: 2px;
            left: 0;
            bottom: 0;
            background: white;
            transition: ${({ theme }) => theme.durations.transition};
          }

          &:hover {
            &::after {
              width: 100%;
              transition: ${({ theme }) => theme.durations.transition};
            }
          }
        }

        &.underline {
          &::after {
            width: 100%;
          }
        }
      }

      &:after {
        content: "";
        position: absolute;
        top: 0;
        left: -10px;
        width: 10px;
        height: 100%;
      }
    }

    @media (min-width: ${({ theme }) => theme.media.desktop_min}) {
      &:hover {
        ul {
          display: block;
        }
      }
    }

    ul {
      width: 100%;
      margin-left: 30px;

      @media (min-width: ${({ theme }) => theme.media.desktop_min}) {
        background: ${({ theme }) => theme.colors.primary_color};
        position: absolute;
        left: calc(100% + 5px);
        display: none;
        top: 0;
        margin-left: -3px;
      }

      li {
        cursor: pointer;
        @media (max-width: ${({ theme }) => theme.media.desktop_min}) {
          font-size: 18px;
          margin: 10px auto 0 0;
          list-style-type: disc;
          font-weight: 400;
        }
        @media (min-width: ${({ theme }) => theme.media.desktop_min}) {
          width: 100%;
          height: 100%;
          text-align: start;
          transition: 0.4s;
          position: relative;

          a {
            padding: 8px 12px;
            display: block;
            width: 100%;
          }

          &:hover {
            background-color: ${({ theme }) => theme.colors.secondary_color};

            &:before {
              content: "";
              height: 100%;
              width: 2px;
              background: white;
              position: absolute;
              left: 0;
              top: 0;
            }
          }
        }
      }
    }
  }

  li {
    @media (min-width: ${({ theme }) => theme.media.desktop_min}) {
      width: 100%;
      height: 100%;
      text-align: start;
      transition: 0.4s;
      position: relative;

      a,
      span {
        padding: 8px 12px;
      }

      &:hover {
        background-color: ${({ theme }) => theme.colors.secondary_color};

        &:before {
          content: "";
          height: 100%;
          width: 2px;
          background: white;
          position: absolute;
          left: 0;
          top: 0;
        }
      }
    }
  }

  & + button {
    display: none !important;
    @media (max-width: ${({ theme }) => theme.media.desktop_min}) {
      position: relative;
      z-index: 3;
      border-color: ${({ theme }) => theme.colors.third_color};
      margin: auto auto 20px;
      font-size: 16px;
      display: block !important;
      a {
        color: ${({ theme }) => theme.colors.third_color};
      }
    }
  }
`

const Box = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
`

const ButtonMobile = styled.div`
  z-index: 20;
  position: relative;
  width: 93%;
  display: flex;
  justify-content: center;
  margin: 20px auto 0;

  a {
    width: 100%;
    max-width: 250px;
    margin-right: 7%;
    padding: 4px 16px;
    background-color: transparent;
    font-size: 14px;
    line-height: 26px;
    font-weight: 700;
    color: ${({ theme }) => theme.colors.third_color};
    border: 2px solid ${({ theme }) => theme.colors.third_color};
    height: 38px;
    align-items: center;
    display: block;
    text-align: center;
    margin-top: 0;
    transition: ${({ theme }) => theme.durations.transition};

    &:hover,
    &:active,
    &:focus {
      color: ${({ theme }) => theme.colors.white};
      border: 2px solid ${({ theme }) => theme.colors.white};
      transition: ${({ theme }) => theme.durations.transition};
    }
  }

  @media (min-width: ${({ theme }) => theme.media.desktop_min}) {
    display: none;
  }
`

const ButtonDesktop = styled.div`
  z-index: 20;

  a {
    padding: 4px 16px;
    background-color: transparent;
    font-size: 16px;
    line-height: 26px;
    font-weight: 500;
    color: ${({ theme }) => theme.colors.primary_color};
    border: 2px solid ${({ theme }) => theme.colors.primary_color};
    cursor: pointer;
    height: 38px;
    align-items: center;
    display: flex;
    margin-top: 0;
    transition: ${({ theme }) => theme.durations.transition};

    &:hover,
    &:active,
    &:focus {
      color: ${({ theme }) => theme.colors.white};
      border: 2px solid ${({ theme }) => theme.colors.white};
      transition: ${({ theme }) => theme.durations.transition};
    }
  }

  @media (max-width: ${({ theme }) => theme.media.tablet_max}) {
    display: none;
  }
`

const CopyRight = styled.div`
  position: relative;
  z-index: 3;
  width: 93%;
  border-top: 1px solid ${({ theme }) => theme.colors.third_color};
  padding-top: 10px;
  text-align: center;
  opacity: 0.6;
  margin: 15px 0;
  @media (min-width: ${({ theme }) => theme.media.desktop_min}) {
    display: none;
  }

  p {
    margin-bottom: 0;
  }

  p,
  a {
    font-size: 10px;
    color: ${({ theme }) => theme.colors.third_color};
    font-weight: 500;
  }

  a {
    display: inline-block;
  }
`
